var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 29.8736613 0 29.8736613 29.8731774 0 29.8731774"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Latch-Insurance---Endorsement-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Theft-Coverage",
    transform: "translate(-47.000000, -249.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(47.000000, 249.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-theft-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3017258,13.8091452 C18.4780161,15.6314032 15.9652742,16.7564032 13.1830161,16.7564032 C10.4022097,16.7564032 7.88898387,15.6314032 6.06575806,13.8091452 C5.77737097,13.5202742 5.51366129,13.2091452 5.26156452,12.8878548 C5.51366129,12.5665645 5.77737097,12.2554355 6.06575806,11.9665645 C7.43124194,10.6020484 9.18333871,9.6285 11.1454355,9.22543548 C10.247371,9.86462903 9.65608065,10.9097903 9.65608065,12.0957581 C9.65608065,14.0443065 11.2359194,15.6236613 13.1835,15.6236613 C15.1315645,15.6236613 16.712371,14.0443065 16.712371,12.0957581 C16.712371,10.9093065 16.1205968,9.86462903 15.2230161,9.22543548 C17.1855968,9.6285 18.9362419,10.6025323 20.3026935,11.9660806 C20.5910806,12.2549516 20.8547903,12.5660806 21.1059194,12.8868871 C20.8528548,13.2091452 20.5901129,13.5202742 20.3017258,13.8091452 M29.4493065,27.2317258 L23.5030161,21.2854355 C25.3770484,18.9057581 26.3201129,16.0310806 26.3201129,13.1544677 C26.3201129,9.78914516 25.0330161,6.4218871 22.4651129,3.85446774 C19.8976935,1.28753226 16.532371,-4.85238865e-05 13.1685,-4.85238865e-05 C9.79882258,-0.000532258065 6.42575806,1.28269355 3.85446774,3.85446774 C1.2851129,6.42333871 -4.83870968e-05,9.79253226 -4.83870968e-05,13.1597903 C-4.83870968e-05,16.5270484 1.2851129,19.8962419 3.85446774,22.464629 C6.4218871,25.0325323 9.78914516,26.319629 13.1549516,26.319629 C16.0315645,26.319629 18.9057581,25.3765645 21.2854355,23.5025323 L27.2322097,29.4488226 C27.5147903,29.7314032 27.8864032,29.8731774 28.2565645,29.8731774 C28.6262419,29.8731774 28.9983387,29.7314032 29.2809194,29.4488226 L29.4493065,29.2804355 C29.7318871,28.9978548 29.8736613,28.6252742 29.8736613,28.2560806 C29.8736613,27.8859194 29.7318871,27.5143065 29.4493065,27.2317258",
    id: "Fill-1",
    fill: "#FBFBFD",
    mask: "url(#mask-theft-2)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheftIcon);
export default __webpack_public_path__ + "static/media/theft_icon.00bf195c.svg";
export { ForwardRef as ReactComponent };